import React, { useEffect, useMemo } from 'react';
import { useRouter } from 'next/router';
import { AreaSelect } from 'client/components/recruitments/SearchForm/AreaSelect';
import { useRecruitmentListContext } from 'client/contexts/recruitments/RecruitmentList';
import { useUrlQueryParams } from 'client/hooks/recruitment/RecruitmentList/useUrlQueryParams';
import { FilterIcon, MarupochiIcon, SearchGrassIcon } from 'client/components/common/icons';
import { Checkbox } from 'src/client/components/recruitments/Checkbox';
import { useAreaTreeQuery, useSortOptionListQuery } from 'src/client/generated';
import { SortButton } from 'client/components/recruitments/SearchForm/SortButton';

export const SearchForm = () => {
  const { searchQueryParams, dispatch } = useRecruitmentListContext();
  const { areaIds, onlyRecruiting, sortOptionId } = searchQueryParams;
  const { data: areaIdData } = useAreaTreeQuery({ fetchPolicy: 'cache-first' });
  const { data: sortOptionsData } = useSortOptionListQuery({ fetchPolicy: 'cache-first' });
  const router = useRouter();

  const { urlQueryParams } = useMemo(() => {
    return useUrlQueryParams({
      ...searchQueryParams,
    });
  }, [searchQueryParams]);

  const handleClickAreaSelect = () => {
    dispatch({
      type: 'changeDisplayMode',
      payload: { displayMode: 'area-modal' },
    });
  };

  const handleClickFilterMore = () => {
    dispatch({
      type: 'changeDisplayMode',
      payload: { displayMode: 'search-modal' },
    });
  };

  const handleClickOnlyRecruiting = () => {
    dispatch({
      type: 'changeOnlyRecruiting',
      payload: { onlyRecruiting: !onlyRecruiting },
    });
  };

  useEffect(() => {
    router.push(
      {
        query: urlQueryParams,
      },
      {
        // @ts-ignore
        pathname: router.query.name,
        query: urlQueryParams,
      },
      { shallow: true },
    );
  }, [urlQueryParams]);

  const showSortSettingModal = () => {
    dispatch({
      type: 'changeDisplayMode',
      payload: {
        displayMode: 'sort-setting-modal',
      },
    });
  };

  const isFilterEnabled = Object.keys(searchQueryParams).filter((key) => key !== 'date').length > 0;

  const areaIdsSelectedValue = useMemo(() => {
    const selectedArray: string[] = [];
    areaIdData?.areaTree.regions.map((o) =>
      o.areaLList.filter((x) => {
        if (areaIds?.includes(x.id)) {
          selectedArray.push(x.name);
        }
      }),
    );
    return selectedArray;
  }, [areaIds, areaIdData]);

  return (
    <div>
      <div className="my-4 mx-3">
        <div className="flex justify-between">
          <AreaSelect
            value={areaIdsSelectedValue}
            labelIcon={<SearchGrassIcon width={15} />}
            onClick={handleClickAreaSelect}
          />
          <div className="flex flex-col text-sm mb-3.5 items-center" onClick={handleClickFilterMore}>
            <div className="relative px-3">
              <FilterIcon width={21} height={20} />
              {isFilterEnabled && (
                <div className="absolute top-0 right-0">
                  <MarupochiIcon width={10} />
                </div>
              )}
            </div>
            <p className="text-xs">絞り込み</p>
          </div>
        </div>
      </div>
      <div className="border-b-gray border-b border-solid"></div>
      <div className="flex ml-4 my-4">
        <Checkbox
          label={'募集中のみ'}
          checked={!!onlyRecruiting}
          onClick={handleClickOnlyRecruiting}
          checkIconWidth={16}
          checkIconHeight={16}
          labelFontSize={12}
        />
        <SortButton
          sortOptionId={sortOptionId}
          sortOptions={sortOptionsData?.sortOptionList.options || []}
          onClick={showSortSettingModal}
        />
      </div>
    </div>
  );
};
